<template>
  <div class="VB_Error VB_Error--400">
    <div>
      <h2>
        Whoops! Something is missing.
      </h2>
      <p>
        Your request is missing one or more parameters, so we can't fetch the
        appropriate content. You can close this window to return to your
        On-Demand player. Please contact ViewMedica support if you reached this
        page through your ViewMedica product or account.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewmedicaBrochure400"
};
</script>
